import Layout from '@/layouts/Layout'

const driver = {
  path: '/driver',
  component: Layout,
  name: 'driver',
  meta: {
    title: '司机',
  },
  children: [
    {
      path: '/driver/customerManage',
      name: 'driver_customer',
      component: () =>
        import('@/pages/customers/customerManage/list/index.vue'),
      meta: { title: '客户列表' },
    },
    // 客户运营列表
    {
      path: '/driver/linkage/customerOperate/list',
      name: 'linkage_board_customer_operateList',
      component: () => import('@/pages/customers/linkage/customerOperate/list/index.vue'),
      meta: { title: '客户运营列表' },
    },
    // 客户数据看板
    {
      path: '/driver/linkage/groupDashboard/list',
      name: 'linkage_board_customer_tenant',
      component: () => import('@/pages/customers/linkage/groupDashboard/list/index.vue'),
      meta: { title: '客户看板' },
    },
    // 个人客户数据影响因子-租赁情况影响因子
    {
      path: '/driver/linkage/personalRentImpactFactor/detail',
      name: 'linkage_board_person_renting_driver_count',
      component: () =>
        import('@/pages/customers/linkage/personalImpactFactors/rentImpactFactor/detail/index.vue'),
      meta: { title: '租赁情况影响因子' },
      hidden: true,
    },
    // 个人客户数据影响因子-网约出车情况影响因子
    {
      path: '/driver/linkage/personalWorkImpactFactor/detail',
      name: 'linkage_board_person_work_situation',
      component: () =>
        import('@/pages/customers/linkage/personalImpactFactors/workImpactFactor/detail/index.vue'),
      meta: { title: '网约出车情况影响因子' },
      hidden: true,
    },
    // 个人客户数据影响因子-网约运营情况影响因子
    {
      path: '/driver/linkage/personalOperateImpactFactor/detail',
      name: 'linkage_board_person_operate_situation',
      component: () =>
        import('@/pages/customers/linkage/personalImpactFactors/operateImpactFactor/detail/index.vue'),
      meta: { title: '网约运营情况影响因子' },
      hidden: true,
    },
    {
      path: '/driver/customerManage/add/person',
      name: 'driver_customer_list_create',
      component: () =>
        import('@/pages/customers/customerManage/edit/person.vue'),
      meta: {
        title: '新增个人客户',
        parent: {
          path: '/driver/customerManage',
          name: 'driver_customer',
          title: '客户列表',
        },
        keepAlive: false,
      },
    },
    {
      path: '/driver/customerManage/add/company',
      name: 'driver_customer_list_create_company',
      component: () =>
        import('@/pages/customers/customerManage/edit/company.vue'),
      meta: {
        title: '新增企业客户',
        parent: {
          path: '/driver/customerManage',
          name: 'driver_customer',
          title: '客户列表',
        },
        keepAlive: false,
      },
    },
    {
      path: '/driver/customerManage/detail',
      name: 'driver_customer_list_detail',
      component: () =>
        import('@/pages/customers/customerManage/detail/index.vue'),
      meta: { title: '客户详情', keepAlive: false },
    },
    {
      path: '/driver/customerManage/edit/person',
      name: 'driver_customer_list_edit',
      component: () =>
        import('@/pages/customers/customerManage/edit/person.vue'),
      meta: {
        title: '编辑个人客户',
        parent: {
          path: '/driver/customerManage',
          name: 'driver_customer',
          title: '客户列表',
        },
        keepAlive: false,
      },
    },
    {
      path: '/driver/customerManage/edit/company',
      name: 'driver_customer_list_edit_company',
      component: () =>
        import('@/pages/customers/customerManage/edit/company.vue'),
      meta: {
        title: '编辑企业客户',
        parent: {
          path: '/driver/customerManage',
          name: 'driver_customer',
          title: '客户列表',
        },
        keepAlive: false,
      },
    },
  ],
}
export default driver
